'use client';
import React, { useState, useEffect, useRef } from 'react';
import ChatWidget from '@/components/ui/ChatWidget';

// SVG Icons
const ArrowRight = ({ className = '' }: { className?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true">
    <path d="M5 12h14" /><path d="m12 5 7 7-7 7" />
  </svg>
);
const PhoneIcon = ({ className = '' }: { className?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true">
    <path d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384" />
  </svg>
);
const ActivityIcon = ({ className = '' }: { className?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true">
    <path d="M22 12h-2.48a2 2 0 0 0-1.93 1.46l-2.35 8.36a.25.25 0 0 1-.48 0L9.24 2.18a.25.25 0 0 0-.48 0l-2.35 8.36A2 2 0 0 1 4.49 12H2" />
  </svg>
);
const ShieldIcon = ({ className = '' }: { className?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true">
    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z" />
  </svg>
);
const GlobeIcon = ({ className = '' }: { className?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true">
    <circle cx="12" cy="12" r="10" /><path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20" /><path d="M2 12h20" />
  </svg>
);
const TrendingDownIcon = ({ className = '' }: { className?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true">
    <path d="M16 17h6v-6" /><path d="m22 17-8.5-8.5-5 5L2 7" />
  </svg>
);
const ClockIcon = ({ className = '' }: { className?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true">
    <circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" />
  </svg>
);
const MicIcon = ({ className = '' }: { className?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true">
    <path d="M12 19v3" /><path d="M19 10v2a7 7 0 0 1-14 0v-2" /><rect x="9" y="2" width="6" height="13" rx="3" />
  </svg>
);
const MessageSquareIcon = ({ className = '' }: { className?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true">
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
  </svg>
);
const DatabaseIcon = ({ className = '' }: { className?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true">
    <ellipse cx="12" cy="5" rx="9" ry="3" /><path d="M3 5V19A9 3 0 0 0 21 19V5" /><path d="M3 12A9 3 0 0 0 21 12" />
  </svg>
);
const WorkflowIcon = ({ className = '' }: { className?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true">
    <rect width="8" height="8" x="3" y="3" rx="2" /><path d="M7 11v4a2 2 0 0 0 2 2h4" /><rect width="8" height="8" x="13" y="13" rx="2" />
  </svg>
);
const MessageCircleIcon = ({ className = '' }: { className?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true">
    <path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z" />
  </svg>
);
const MegaphoneIcon = ({ className = '' }: { className?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true">
    <path d="m3 11 18-5v12L3 14v-3z" /><path d="M11.6 16.8a3 3 0 1 1-5.8-1.6" />
  </svg>
);
const PanelsTopLeftIcon = ({ className = '' }: { className?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true">
    <rect width="18" height="18" x="3" y="3" rx="2" /><path d="M3 9h18" /><path d="M9 21V9" />
  </svg>
);
const WrenchIcon = ({ className = '' }: { className?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true">
    <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />
  </svg>
);
const SparklesIcon = ({ className = '' }: { className?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true">
    <path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z" />
    <path d="M20 3v4" /><path d="M22 5h-4" /><path d="M4 17v2" /><path d="M5 18H3" />
  </svg>
);
const ArrowUpRightIcon = ({ className = '' }: { className?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true">
    <path d="M7 7h10v10" /><path d="M7 17 17 7" />
  </svg>
);
const CheckIcon = ({ className = '' }: { className?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true">
    <path d="M20 6 9 17l-5-5" />
  </svg>
);
const MailIcon = ({ className = '' }: { className?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true">
    <path d="m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7" /><rect x="2" y="4" width="20" height="16" rx="2" />
  </svg>
);
const SendIcon = ({ className = '' }: { className?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true">
    <path d="M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z" />
    <path d="m21.854 2.147-10.94 10.939" />
  </svg>
);
const StarIcon = ({ className = '' }: { className?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true">
    <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z" />
  </svg>
);
const ChevronDownIcon = ({ className = '' }: { className?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true">
    <path d="m6 9 6 6 6-6" />
  </svg>
);
const CalendarClockIcon = ({ className = '' }: { className?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true">
    <path d="M21 7.5V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h3.5" />
    <path d="M16 2v4" /><path d="M8 2v4" /><path d="M3 10h5" />
    <path d="M17.5 17.5 16 16.3V14" /><circle cx="16" cy="16" r="6" />
  </svg>
);
const TwitterIcon = ({ className = '' }: { className?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true">
    <path d="M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6 2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4-.9-4.2 4-6.6 7-3.8 1.1 0 3-1.2 3-1.2z" />
  </svg>
);
const LinkedinIcon = ({ className = '' }: { className?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true">
    <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" />
    <rect width="4" height="12" x="2" y="9" /><circle cx="4" cy="4" r="2" />
  </svg>
);
const GithubIcon = ({ className = '' }: { className?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true">
    <path d="M15 22v-4a4.8 4.8 0 0 0-1-3.5c3 0 6-2 6-5.5.08-1.25-.27-2.48-1-3.5.28-1.15.28-2.35 0-3.5 0 0-1 0-3 1.5-2.64-.5-5.36-.5-8 0C6 2 5 2 5 2c-.3 1.15-.3 2.35 0 3.5A5.403 5.403 0 0 0 4 9c0 3.5 3 5.5 6 5.5-.39.49-.68 1.05-.85 1.65-.17.6-.22 1.23-.15 1.85v4" />
    <path d="M9 18c-4.51 2-5-2-7-2" />
  </svg>
);

// Waveform Component
const Waveform = ({ bars = 20, active = true }: { bars?: number; active?: boolean }) => {
  const [barStyles, setBarStyles] = React.useState<{ height: string; animationDuration: string }[]>([]);

  React.useEffect(() => {
    setBarStyles(
      Array.from({ length: bars }).map(() => ({
        height: `${Math.random() * 70 + 30}%`,
        animationDuration: `${0.8 + Math.random() * 0.8}s`,
      }))
    );
  }, [bars]);

  return (
    <div className="flex items-end gap-[3px] h-10">
      {Array.from({ length: bars }).map((_, i) => (
        <div
          key={i}
          className="waveform-bar"
          style={{
            height: barStyles[i]?.height ?? '50%',
            animationDelay: `${i * 0.06}s`,
            animationDuration: barStyles[i]?.animationDuration ?? '1s',
            opacity: active ? 1 : 0.3,
          }}
        />
      ))}
    </div>
  );
};

export default function MGriffinPage() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [rotatingWord, setRotatingWord] = useState('Automated');
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const [formData, setFormData] = useState({ name: '', phone: '', phoneCode: '+91', email: '', website: '', message: '' });
  const [terminalLines, setTerminalLines] = useState<string[]>([]);
  const heroRef = useRef<HTMLDivElement>(null);

  // Scroll reveal
  useEffect(() => {
    const elements = document.querySelectorAll('.section-reveal');
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px -40px 0px' }
    );
    elements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  const rotatingWords = ['Automated', 'Scalable', 'Autonomous', 'Intelligent', 'Always On'];

  const terminalSequence = [
    '> Initializing MGriffin AI Core...',
    '> Loading voice synthesis engine...',
    '> Connecting to LLM cluster...',
    '> Agent ready. Latency: 247ms',
    '> Incoming call detected...',
    '> [AGENT] "Hello! How can I help you today?"',
    '> Intent classified: appointment_booking',
    '> CRM sync: HubSpot ✓',
    '> Calendar slot booked: 2:30 PM',
    '> Call duration: 1m 42s | Outcome: ✓ Converted',
  ];

  useEffect(() => {
    let idx = 0;
    const wordInterval = setInterval(() => {
      idx = (idx + 1) % rotatingWords.length;
      setRotatingWord(rotatingWords[idx]);
    }, 2200);
    return () => clearInterval(wordInterval);
  }, []);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      const hero = heroRef.current;
      if (hero) {
        const rect = hero.getBoundingClientRect();
        const x = ((e.clientX - rect.left) / rect.width) * 100;
        const y = ((e.clientY - rect.top) / rect.height) * 100;
        hero.style.setProperty('--mx', `${x}%`);
        hero.style.setProperty('--my', `${y}%`);
      }
    };
    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  useEffect(() => {
    let lineIdx = 0;
    const addLine = () => {
      if (lineIdx < terminalSequence.length) {
        const nextLine = terminalSequence[lineIdx];
        if (nextLine !== undefined) {
          setTerminalLines(prev => [...prev.slice(-8), nextLine]);
        }
        lineIdx++;
        setTimeout(addLine, 900 + Math.random() * 600);
      } else {
        setTimeout(() => {
          lineIdx = 0;
          setTerminalLines([]);
          setTimeout(addLine, 1000);
        }, 3000);
      }
    };
    const timer = setTimeout(addLine, 1500);
    return () => clearTimeout(timer);
  }, []);

  const faqItems = [
    { q: 'How does the AI voice agent work?', a: 'Our AI voice agents use large language models combined with real-time speech synthesis and recognition. When a call comes in, the agent listens, understands intent, retrieves relevant information from your knowledge base, and responds in natural speech — all in under 300ms.' },
    { q: 'Does it sound robotic?', a: 'No. We use the latest neural TTS voices with natural prosody, breathing patterns and conversational pacing. Most callers cannot tell they are speaking to an AI.' },
    { q: 'What languages does it support?', a: 'We support 30+ languages including English, Spanish, Hindi, French, German, Arabic, Mandarin, Portuguese and more — with native accents and auto-detection.' },
    { q: 'Which industries do you serve?', a: 'We are sector-agnostic. We have deployed agents for healthcare, hospitality, real estate, e-commerce, finance, logistics, education, SaaS, legal, and more.' },
    { q: "What happens if the AI can't handle a question?", a: 'The agent seamlessly transfers the call to a human agent with full context — the transcript, caller details and intent — so your team can pick up without asking the caller to repeat themselves.' },
    { q: 'Can it make outbound calls?', a: 'Yes. Our outbound agents handle lead follow-up, appointment reminders, payment collections, NPS surveys and more — at scale, 24/7.' },
    { q: 'Is my data secure?', a: 'Yes. We are SOC 2 aligned, HIPAA-ready and GDPR compliant. All data is encrypted in transit and at rest. We never use your data to train models.' },
    { q: 'How long does it take to set up?', a: 'Typically 7–14 days from sign-off to go-live. This includes knowledge transfer, voice tuning, CRM integration and a parallel staging period.' },
    { q: 'Can I integrate this with my existing CRM?', a: 'Yes. We integrate natively with HubSpot, Salesforce, Zoho, Pipedrive, and most CRMs via API. We also support Zendesk, Intercom, Freshdesk and custom webhooks.' },
    { q: 'How is pricing structured?', a: 'Every engagement is custom-quoted after a 45-minute discovery call. Pricing typically includes a one-time setup fee and a monthly recurring fee based on call volume and features.' },
  ];

  const agents = [
    { num: '01', title: 'Lead Capture', icon: <ActivityIcon className="w-5 h-5" />, color: '#4ade80', desc: 'Calls back new leads in under 2 minutes, qualifies intent, books calendar slots.' },
    { num: '02', title: 'Outbound Outreach', icon: <MegaphoneIcon className="w-5 h-5" />, color: '#60a5fa', desc: 'Daily multilingual outbound campaigns — pitches, offers, surveys, win-backs.' },
    { num: '03', title: 'NPS & Testimonials', icon: <StarIcon className="w-5 h-5" />, color: '#f59e0b', desc: 'Calls happy customers for voice testimonials and NPS scores.' },
    { num: '04', title: 'Internal Assistant', icon: <DatabaseIcon className="w-5 h-5" />, color: '#a78bfa', desc: 'Transcribes team calls, extracts action items, flags stalled accounts.' },
    { num: '05', title: 'Onboarding Agent', icon: <WorkflowIcon className="w-5 h-5" />, color: '#34d399', desc: 'Chases missing documents by voice, verifies details, sends links via WhatsApp.' },
    { num: '06', title: 'Payment Reminders', icon: <PhoneIcon className="w-5 h-5" />, color: '#fb923c', desc: 'Escalating-tone collections calls that capture commitment instantly.' },
    { num: '07', title: 'Interview Prep', icon: <MicIcon className="w-5 h-5" />, color: '#e879f9', desc: 'Mock interviews, document checks and generated prep questions.' },
    { num: '08', title: 'Referral & Reputation', icon: <SparklesIcon className="w-5 h-5" />, color: '#e8c478', desc: 'Post-purchase calls for Google reviews and referral introductions.' },
  ];

  const marqueeItems = [
    { source: 'Markets & Markets', text: '$7.84B → $52.62B · 46.3% CAGR' },
    { source: 'DataGrid', text: '88% enterprises using AI regularly' },
    { source: 'GM Insights', text: '$105.6B market by 2034' },
    { source: 'PwC', text: '66% reporting measurable productivity gains' },
    { source: 'Fronseye', text: '30–300% ROI in first year' },
    { source: 'Ardem', text: '240% average ROI · 6–9 month payback' },
    { source: 'Protiviti', text: '77% expect agents to handle repetitive decisions' },
  ];

  const testimonials = [
    { initials: 'AS', name: 'Anika Sharma', role: 'COO, Northwind Hotels', text: '"MGriffin\'s voice agents handle 80% of our front-desk calls. Guests genuinely think they\'re talking to a person."' },
    { initials: 'DO', name: 'Daniel Okafor', role: 'Head of Support, BrightCart', text: '"We cut our support backlog by 70% in six weeks. The setup was painless and the team is unbelievably responsive."' },
    { initials: 'PM', name: 'Priya Menon', role: 'Founder, ClinicQ', text: '"Our patients can book, reschedule and ask questions at 2am. Revenue from after-hours appointments is up 3x."' },
    { initials: 'MH', name: 'Marcus Hale', role: 'VP Sales, Quantica', text: '"The outbound agent qualifies leads better than half my SDR team. ROI was visible inside the first month."' },
  ];

  return (
    <div className="App" style={{ background: '#0a0a0b', color: '#f5f3ef', minHeight: '100vh' }}>

      {/* HEADER */}
      <header
        className="fixed top-0 left-0 right-0 z-50 transition-all duration-300"
        style={{
          backdropFilter: 'blur(6px)',
          background: scrolled ? 'rgba(3,4,10,0.9)' : 'rgba(3,4,10,0.18)',
          borderBottom: scrolled ? '1px solid rgba(212,168,91,0.1)' : '1px solid transparent',
        }}
      >
        <div className="max-w-[1280px] mx-auto px-6 lg:px-10 h-[68px] flex items-center justify-between">
          <a href="#top" className="flex items-center">
            <div className="flex items-center gap-2">
              <div
                className="relative flex items-center justify-center rounded-md glitch-block"
                style={{ width: 28, height: 28, background: 'linear-gradient(135deg, #e8c478 0%, #d4a85b 100%)', boxShadow: 'rgba(212,168,91,0.6) 0px 4px 14px -4px, rgba(255,255,255,0.3) 0px 1px 0px inset' }}
              >
                <span className="font-serif-display text-[#03040a] leading-none" style={{ fontSize: 18.2 }}>M</span>
              </div>
              <div className="leading-tight">
                <div className="text-[15px] font-semibold tracking-tight text-white rgb-split">MGriffin</div>
                <div className="text-[10px] uppercase tracking-[0.18em] text-[#d4a85b]">Business Solutions</div>
              </div>
            </div>
          </a>
          <nav className="hidden md:flex items-center gap-1">
            {['Voice Agents', 'Services', 'Sectors', 'Process', 'FAQ'].map((item) => (
              <a
                key={item}
                href={`#${{ 'Voice Agents': 'agents', 'Services': 'services', 'Sectors': 'sectors', 'Process': 'process', 'FAQ': 'faq' }[item] || item.toLowerCase().replace(' ', '')}`}
                className="px-3.5 py-2 rounded-full text-[13.5px] font-medium transition-colors hover:text-white rgb-split"
                style={{ color: 'rgba(200,220,255,0.85)' }}
              >
                {item}
              </a>
            ))}
          </nav>
          <div className="flex items-center gap-2">
            <a href="#contact" className="btn-gold inline-flex items-center gap-2 px-4 py-2 rounded-full text-[13px] font-semibold glitch-border">Get Started</a>
            <button
              className="md:hidden ml-1 p-2 rounded-md text-white"
              aria-label="menu"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            >
              <div className="w-5 flex flex-col gap-1">
                <span className="h-px bg-current block"></span>
                <span className="h-px bg-current block"></span>
                <span className="h-px bg-current block"></span>
              </div>
            </button>
          </div>
        </div>
        {mobileMenuOpen && (
          <div className="md:hidden px-6 pb-4" style={{ background: 'rgba(3,4,10,0.97)', borderBottom: '1px solid rgba(212,168,91,0.1)' }}>
            {['Voice Agents', 'Services', 'Sectors', 'Process', 'FAQ'].map((item) => (
              <a
                key={item}
                href={`#${{ 'Voice Agents': 'agents', 'Services': 'services', 'Sectors': 'sectors', 'Process': 'process', 'FAQ': 'faq' }[item] || item.toLowerCase().replace(' ', '')}`}
                className="block py-3 text-[14px] text-neutral-300 hover:text-white border-b border-white/5"
                onClick={() => setMobileMenuOpen(false)}
              >
                {item}
              </a>
            ))}
          </div>
        )}
      </header>

      {/* HERO SECTION */}
      <section id="top" className="section-reveal relative hero-dark-stage overflow-hidden scanline-glitch" style={{ minHeight: '100vh' }} ref={heroRef}>
        <div className="perspective-grid"></div>
        <div className="horizon-glow"></div>
        <span className="data-stream" style={{ left: '4%', top: '10%', height: '40%', animationDelay: '0s' }}></span>
        <span className="data-stream" style={{ left: '14%', top: '10%', height: '60%', animationDelay: '1.2s' }}></span>
        <span className="data-stream" style={{ left: '82%', top: '10%', height: '50%', animationDelay: '0.6s' }}></span>
        <span className="data-stream" style={{ left: '94%', top: '10%', height: '35%', animationDelay: '2s' }}></span>
        <span className="data-stream" style={{ left: '50%', top: '10%', height: '45%', animationDelay: '3s' }}></span>
        <div className="scanlines"></div>
        <div className="mouse-spot"></div>
        {/* 3D depth orbs — gold palette */}
        <div className="orb" style={{ width: 500, height: 500, background: 'rgba(212,168,91,0.12)', top: -180, left: -180 }}></div>
        <div className="orb" style={{ width: 420, height: 420, background: 'rgba(184,137,46,0.14)', bottom: -160, right: -160, animationDelay: '3s' }}></div>
        <div className="orb" style={{ width: 280, height: 280, background: 'rgba(232,196,120,0.08)', top: '30%', right: '8%', animationDelay: '1s', filter: 'blur(50px)' }}></div>
        <div className="orb" style={{ width: 240, height: 240, background: 'rgba(184,137,46,0.1)', bottom: '20%', left: '12%', animationDelay: '2s', filter: 'blur(50px)' }}></div>
        {/* Extra depth layer */}
        <div className="orb" style={{ width: 600, height: 600, background: 'rgba(212,168,91,0.05)', top: '20%', left: '30%', animationDelay: '5s', filter: 'blur(100px)' }}></div>

        {/* Watermark M */}
        <div className="absolute inset-0 flex items-start justify-center pointer-events-none opacity-[0.1]" style={{ paddingTop: '12vh' }}>
          <div className="relative flex items-center justify-center">
            <div className="absolute rounded-full" style={{ width: 360, height: 360, background: 'radial-gradient(circle at 35% 30%, rgba(212,168,91,0.3) 0%, rgba(184,137,46,0.12) 30%, transparent 65%)', filter: 'blur(28px)' }}></div>
            <span className="m-glass font-serif-display select-none glitch-block" style={{ fontSize: 'clamp(260px, 36vw, 480px)', lineHeight: 1, letterSpacing: '-0.04em' }}>M</span>
          </div>
        </div>

        {/* 3D Spheres */}
        <div className="hidden xl:block absolute pointer-events-none" style={{ right: '4%', top: '12%' }}>
          <div className="relative" style={{ width: 150, height: 150 }}>
            <div className="sphere-3d absolute inset-0"></div>
            <div className="orbit-ring" style={{ inset: -22 }}></div>
          </div>
        </div>
        <div className="hidden xl:block absolute pointer-events-none" style={{ left: '4%', top: '15%' }}>
          <div className="relative" style={{ width: 110, height: 110 }}>
            <div className="sphere-3d absolute inset-0" style={{ animationDelay: '2s' }}></div>
          </div>
        </div>

        {/* HUD Chips */}
        <div className="hud-chip" style={{ top: '40%', left: '3%' }}>
          <span className="live-dot"></span>
          <span className="font-mono-tech text-[#d4a85b]">LIVE</span>
          Agent · 280ms
        </div>
        <div className="hud-chip" style={{ top: '40%', right: '3%', animationDelay: '1.5s' }}>
          <PhoneIcon className="w-3 h-3 text-[#d4a85b]" />
          25+ concurrent calls
        </div>
        <div className="hud-chip" style={{ top: '60%', left: '5%', animationDelay: '2.5s' }}>
          <ActivityIcon className="w-3 h-3 text-[#d4a85b]" />
          EN → ES → HI auto-detect
        </div>
        <div className="hud-chip" style={{ top: '60%', right: '5%', animationDelay: '3.5s' }}>
          <span className="font-mono-tech text-[#d4a85b]">99.9%</span>
          uptime SLA
        </div>

        {/* Hero Content */}
        <div className="relative max-w-[1180px] mx-auto px-6 lg:px-10 pt-40 pb-44 text-center flex flex-col items-center">
          <div
            className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-[11.5px] uppercase tracking-[0.22em] mb-8"
            style={{ color: 'rgb(212,168,91)', background: 'rgba(20,14,4,0.7)', border: '1px solid rgba(212,168,91,0.3)', backdropFilter: 'blur(10px)' }}
          >
            <span className="live-dot"></span>
            Conversational AI Infrastructure · 24/7
          </div>

          <h1 className="font-serif-display leading-[1.02] tracking-tight" style={{ fontSize: 'clamp(44px, 6.8vw, 92px)' }}>
            <span
              className="glitch-text"
              data-text="Conversational"
              style={{ color: 'rgba(232,240,255,0.95)', display: 'block' }}
            >
              Conversational
            </span>
            <span style={{ color: 'rgba(232,240,255,0.92)', display: 'block' }}>Agents that are</span>
            <span key={rotatingWord} className="rotating-word text-gold-gradient neon-flicker" style={{ fontWeight: 600, fontFamily: 'Inter', letterSpacing: '-0.02em' }}>{rotatingWord}</span>
          </h1>

          {/* Waveform visual */}
          <div className="mt-8 flex justify-center">
            <Waveform bars={32} active={true} />
          </div>

          <p className="mt-6 mx-auto max-w-[580px] text-[15px] leading-[1.7]" style={{ color: 'rgba(180,200,240,0.65)' }}>
            Deploy intelligent voice &amp; chat agents for any business, in any sector.
          </p>

          <div className="mt-8 flex items-center justify-center gap-3 flex-wrap">
            <a href="#contact" className="btn-gold inline-flex items-center gap-2 px-6 py-3.5 rounded-full text-[14px] font-semibold glitch-border">
              Get started <ArrowRight className="w-4 h-4" />
            </a>
            <a
              href="#services"
              className="inline-flex items-center gap-2 px-6 py-3.5 rounded-full text-[14px] font-medium"
              style={{ color: 'rgb(232,196,120)', border: '1px solid rgba(212,168,91,0.3)', background: 'rgba(20,14,4,0.5)', backdropFilter: 'blur(10px)' }}
            >
              See what we build <ArrowRight className="w-4 h-4" />
            </a>
          </div>

          {/* Trust badges */}
          <div className="mt-12 flex justify-center">
            <div
              className="inline-flex items-center gap-6 flex-wrap justify-center px-6 py-3 rounded-full"
              style={{ background: 'rgba(10,8,3,0.7)', border: '1px solid rgba(212,168,91,0.15)', backdropFilter: 'blur(14px)', color: 'rgba(212,168,91,0.78)', fontSize: 12.5 }}
            >
              <span className="flex items-center gap-2"><span className="live-dot" style={{ width: 6, height: 6 }}></span> SOC 2 aligned</span>
              <span className="w-px h-3 bg-white/15"></span>
              <span>HIPAA-ready</span>
              <span className="w-px h-3 bg-white/15"></span>
              <span>GDPR compliant</span>
              <span className="w-px h-3 bg-white/15"></span>
              <span><span className="font-mono-tech text-[#d4a85b]">&lt;300ms</span> response</span>
            </div>
          </div>
        </div>
      </section>

      {/* CONVERSATIONS THAT FEEL HUMAN */}
      <section id="voice" className="section-reveal relative section-warm-deep py-28 border-t border-white/5 overflow-hidden">
        <div className="absolute inset-0 pointer-events-none overflow-hidden" aria-hidden="true">
          <div className="perspective-grid-section"></div>
          <div className="horizon-glow-section"></div>
          <div className="scanlines" style={{ opacity: 0.35 }}></div>
          <div className="orb" style={{ width: 360, height: 360, background: 'rgba(212,168,91,0.12)', top: -80, left: -120 }}></div>
          <div className="orb" style={{ width: 320, height: 320, background: 'rgba(184,137,46,0.1)', animationDelay: '3s', bottom: -100, right: -120 }}></div>
          <div className="orb" style={{ width: 220, height: 220, background: 'rgba(232,196,120,0.06)', top: '40%', right: '5%', filter: 'blur(50px)' }}></div>
          <div className="orb" style={{ width: 200, height: 200, background: 'rgba(184,137,46,0.07)', bottom: '20%', left: '5%', filter: 'blur(50px)' }}></div>
        </div>
        <div className="relative z-10 max-w-[1180px] mx-auto px-6 lg:px-10 flex flex-col items-center text-center">
          <div className="text-[11px] uppercase tracking-[0.28em] text-[#d4a85b] mb-5">Voice &amp; Chat AI</div>
          <h2 className="font-serif-display text-white leading-[1.05]" style={{ fontSize: 'clamp(36px, 5vw, 72px)' }}>
            Conversations that<br />
            <span className="text-gold-gradient glitch-text neon-flicker" data-text="feel human.">feel human.</span>
          </h2>

          {/* Live waveform centered */}
          <div className="mt-10 flex flex-col items-center gap-3">
            <div className="flex items-center gap-3">
              <span className="live-dot"></span>
              <span className="font-mono-tech text-[11px] text-[#d4a85b] tracking-widest">AGENT SPEAKING</span>
            </div>
            <Waveform bars={48} active={true} />
          </div>

          {/* 4 symbol-icon stat cards centered */}
          <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-4 w-full max-w-[860px]">
            {[
              { val: '<300ms', label: 'Response', icon: <ActivityIcon className="w-7 h-7" />, color: '#d4a85b', sym: '⚡' },
              { val: '30+', label: 'Languages', icon: <GlobeIcon className="w-7 h-7" />, color: '#e8c478', sym: '🌐' },
              { val: '99.9%', label: 'Uptime', icon: <ShieldIcon className="w-7 h-7" />, color: '#4ade80', sym: '🛡' },
              { val: '85%', label: 'Cost Cut', icon: <TrendingDownIcon className="w-7 h-7" />, color: '#d4a85b', sym: '↓' },
            ].map((s, i) => (
              <div key={i} className="stat-card flex flex-col items-center text-center py-7">
                <div style={{ color: s.color }} className="mb-3">{s.icon}</div>
                <div className="font-mono-tech text-[32px] font-bold leading-none" style={{ color: s.color }}>{s.val}</div>
                <div className="text-[11px] text-neutral-400 mt-2 uppercase tracking-widest">{s.label}</div>
              </div>
            ))}
          </div>

          {/* Terminal Window centered */}
          <div className="mt-14 w-full max-w-[680px] terminal-window">
            <div className="terminal-header">
              <div className="terminal-dot" style={{ background: '#ff5f57' }}></div>
              <div className="terminal-dot" style={{ background: '#febc2e' }}></div>
              <div className="terminal-dot" style={{ background: '#28c840' }}></div>
              <span className="ml-3 font-mono-tech text-[11px] text-neutral-500">mgriffin-agent · live session</span>
              <span className="ml-auto live-indicator">
                <span className="live-dot" style={{ width: 6, height: 6 }}></span>
                <span className="font-mono-tech text-[10px] text-emerald-400">LIVE</span>
              </span>
            </div>
            <div className="terminal-body">
              {terminalLines.map((line, i) => (
                <div
                  key={i}
                  className="font-mono-tech text-[12px]"
                  style={{
                    color: line?.includes('[AGENT]') ? '#d4a85b' :
                           line?.includes('✓') ? '#4ade80' :
                           line?.includes('Initializing') || line?.includes('Loading') ? '#a78bfa' :
                           'rgba(200,220,255,0.7)',
                    opacity: i === terminalLines.length - 1 ? 1 : 0.7 - (terminalLines.length - 1 - i) * 0.08,
                  }}
                >
                  {line}
                </div>
              ))}
              <div className="flex items-center gap-1 mt-1">
                <span className="font-mono-tech text-[12px] text-neutral-600">{'>'}</span>
                <span className="terminal-cursor"></span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SERVICES SECTION */}
      <section id="services" className="section-reveal relative section-warm py-28 border-t border-white/5 overflow-hidden">
        <div className="absolute inset-0 pointer-events-none overflow-hidden" aria-hidden="true">
          <div className="perspective-grid-top"></div>
          <div className="scanlines" style={{ opacity: 0.35 }}></div>
          <div className="orb" style={{ width: 360, height: 360, background: 'rgba(184,137,46,0.1)', top: -80, left: -120 }}></div>
          <div className="orb" style={{ width: 300, height: 300, background: 'rgba(212,168,91,0.08)', bottom: -80, right: -100, animationDelay: '4s' }}></div>
        </div>
        <div className="relative z-10 max-w-[1180px] mx-auto px-6 lg:px-10">
          <div className="flex flex-col items-center gap-4 mb-14 text-center">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-[10.5px] uppercase tracking-[0.22em]"
              style={{ color: 'rgb(212,168,91)', background: 'rgba(212,168,91,0.06)', border: '1px solid rgba(212,168,91,0.25)' }}>
              <span className="live-dot" style={{ width: 6, height: 6 }}></span> Core product
            </div>
            <h2 className="font-serif-display text-white leading-[1.06] max-w-[820px]" style={{ fontSize: 'clamp(34px, 4.6vw, 60px)' }}>
              Conversational AI<br /><span className="text-gold-gradient">infrastructure.</span>
            </h2>
          </div>
          <div className="grid md:grid-cols-2 gap-3">
            {[
              { icon: <MicIcon className="w-6 h-6 text-[#d4a85b]" />, title: 'Voice Agents', sym: '🎙', features: ['⚡ Sub-300ms latency', '🗣 Human-like voices', '🌐 30+ languages', '🔄 Live human handoff'], color: '#d4a85b' },
              { icon: <MessageSquareIcon className="w-6 h-6 text-[#e8c478]" />, title: 'WhatsApp & Chat', sym: '💬', features: ['🎨 Flow design + AI training', '🔗 CRM-integrated', '🧠 Context-aware', '✨ Branded tone'], color: '#e8c478' },
              { icon: <DatabaseIcon className="w-6 h-6 text-[#a78bfa]" />, title: 'Internal RAG Systems', sym: '🧠', features: ['📁 Drive, Notion, Slack', '🔒 Permission-aware', '📌 Cited answers', '♻️ Continuous indexing'], color: '#a78bfa' },
              { icon: <WorkflowIcon className="w-6 h-6 text-[#34d399]" />, title: 'Tool Integrations', sym: '⚙️', features: ['🏢 HubSpot, Salesforce', '📅 Google / Outlook', '🎫 Zendesk, Intercom', '🔌 Custom webhooks'], color: '#34d399' },
            ].map((svc, i) => (
              <div key={i} className="holo-card tilt-card spotlight p-8 relative overflow-hidden">
                <div className="flex flex-col items-center text-center gap-4">
                  <div
                    className="w-14 h-14 rounded-2xl flex items-center justify-center"
                    style={{ background: `linear-gradient(135deg, ${svc.color}22, ${svc.color}08)`, border: `1px solid ${svc.color}55` }}
                  >
                    {svc.icon}
                  </div>
                  <h3 className="text-[22px] font-semibold text-white tracking-tight">{svc.title}</h3>
                  <ul className="mt-2 space-y-2 w-full">
                    {svc.features.map((f, j) => (
                      <li key={j} className="flex items-center justify-center gap-2 text-[13.5px] text-neutral-300">
                        {f}
                      </li>
                    ))}
                  </ul>
                  <a href="#contact" className="mt-3 inline-flex items-center gap-1.5 text-[12.5px] font-medium" style={{ color: svc.color }}>
                    Get a quote <ArrowRight className="w-3.5 h-3.5" />
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* AGENTS SECTION */}
      <section id="agents" className="section-reveal relative section-warm-alt py-28 border-t border-white/5 overflow-hidden">
        <div className="absolute inset-0 pointer-events-none overflow-hidden" aria-hidden="true">
          <div className="perspective-grid-section"></div>
          <div className="horizon-glow-section"></div>
          <div className="scanlines" style={{ opacity: 0.35 }}></div>
          <div className="orb" style={{ width: 360, height: 360, background: 'rgba(184,137,46,0.14)', top: -80, right: -120 }}></div>
          <div className="orb" style={{ width: 280, height: 280, background: 'rgba(212,168,91,0.08)', bottom: -80, left: -100, animationDelay: '5s' }}></div>
        </div>
        <div className="relative z-10 max-w-[1180px] mx-auto px-6 lg:px-10">
          <div className="max-w-[820px] mx-auto text-center mb-14">
            <div className="text-[11px] uppercase tracking-[0.28em] text-[#d4a85b] mb-5">The Eight · Voice Agent Suite</div>
            <h2 className="font-serif-display text-white leading-[1.06]" style={{ fontSize: 'clamp(34px, 4.6vw, 60px)' }}>
              Eight purpose-built agents.<br /><span className="text-gold-gradient">One conversational core.</span>
            </h2>
          </div>
          <div className="mt-4 grid sm:grid-cols-2 lg:grid-cols-4 gap-3">
            {agents.map((agent) => (
              <a key={agent.num} href="#contact" className="holo-card tilt-card rounded-2xl p-6 relative overflow-hidden group block">
                <div className="flex items-start justify-between mb-4">
                  <div
                    className="font-mono-tech text-[10px] tracking-widest px-2 py-0.5 rounded"
                    style={{ color: agent.color, background: `${agent.color}18`, border: `1px solid ${agent.color}40` }}
                  >
                    {agent.num}
                  </div>
                  <div style={{ color: agent.color, opacity: 0.7 }}>{agent.icon}</div>
                </div>
                <h3 className="text-white text-[15px] font-medium leading-snug">{agent.title}</h3>
                <p className="mt-2 text-[12.5px] text-neutral-500 leading-[1.6]">{agent.desc}</p>
                <div className="mt-5 flex items-center gap-2 text-[11.5px] font-medium" style={{ color: agent.color }}>
                  <span>Deploy</span>
                  <ArrowRight className="w-3 h-3" />
                </div>
                <div className="absolute bottom-0 left-0 right-0 h-[2px] opacity-0 group-hover:opacity-100 transition-opacity"
                  style={{ background: `linear-gradient(90deg, transparent, ${agent.color}, transparent)` }}></div>
              </a>
            ))}
          </div>
          <div className="mt-10 text-center">
            <a href="#contact" className="btn-gold inline-flex items-center gap-2 px-6 py-3 rounded-full text-[13.5px] font-semibold">
              Contact us for a quote <ArrowRight className="w-4 h-4" />
            </a>
          </div>
        </div>
      </section>

      {/* MORE SERVICES SECTION */}
      <section id="more-services" className="section-reveal relative section-warm-center py-28 border-t border-white/5 overflow-hidden">
        <div className="absolute inset-0 pointer-events-none overflow-hidden" aria-hidden="true">
          <div className="perspective-grid-top"></div>
          <div className="scanlines" style={{ opacity: 0.35 }}></div>
          <div className="orb" style={{ width: 360, height: 360, background: 'rgba(212,168,91,0.1)', top: -80, left: -120 }}></div>
        </div>
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute top-1/3 left-1/2 -translate-x-1/2 w-[700px] h-[700px] conic-glow opacity-20"></div>
        </div>
        <div className="relative z-10 max-w-[1180px] mx-auto px-6 lg:px-10">
          <div className="flex flex-col items-center gap-4 mb-14 text-center">
            <div className="text-[11px] uppercase tracking-[0.28em] text-[#d4a85b]">Beyond conversational AI</div>
            <h2 className="font-serif-display text-white leading-[1.06] max-w-[820px]" style={{ fontSize: 'clamp(34px, 4.6vw, 60px)' }}>
              The full growth stack —<br /><span className="text-gold-gradient">one partner.</span>
            </h2>
          </div>
          <div className="grid md:grid-cols-2 gap-3">
            {[
              { icon: <MessageCircleIcon className="w-6 h-6 text-[#25d366]" />, title: 'WhatsApp Chatbot', features: ['💬 Conversational flows', '🤖 AI-trained on your data', '💳 CRM + payment links', '📢 Broadcast + opt-in'], color: '#25d366' },
              { icon: <MegaphoneIcon className="w-6 h-6 text-[#f59e0b]" />, title: 'Digital Marketing', features: ['📱 Social media management', '✍️ Content + email', '📈 SEO & analytics', '📊 Monthly reports'], color: '#f59e0b' },
              { icon: <PanelsTopLeftIcon className="w-6 h-6 text-[#60a5fa]" />, title: 'Web Development', features: ['🌐 Landing pages & sites', '⚙️ Custom platforms', '🛒 E-commerce & portals', '🔌 API + integrations'], color: '#60a5fa' },
              { icon: <WrenchIcon className="w-6 h-6 text-[#e879f9]" />, title: 'Website Maintenance', features: ['🔒 Security patches', '⚡ Performance & SEO', '🛠 Up to 20 dev hours/mo', '🧪 A/B testing'], color: '#e879f9' },
            ].map((svc, i) => (
              <div key={i} className="holo-card tilt-card spotlight rounded-2xl p-8 relative overflow-hidden">
                <div className="flex flex-col items-center text-center gap-4">
                  <div
                    className="w-14 h-14 rounded-2xl flex items-center justify-center"
                    style={{ background: `linear-gradient(135deg, ${svc.color}22, ${svc.color}08)`, border: `1px solid ${svc.color}55` }}
                  >
                    {svc.icon}
                  </div>
                  <h3 className="text-[22px] font-semibold text-white tracking-tight">{svc.title}</h3>
                  <ul className="mt-2 grid grid-cols-2 gap-2 w-full">
                    {svc.features.map((f, j) => (
                      <li key={j} className="flex items-center justify-center gap-1.5 text-[12.5px] text-neutral-300 text-center">
                        {f}
                      </li>
                    ))}
                  </ul>
                  <a href="#contact" className="mt-3 inline-flex items-center gap-1.5 text-[12.5px] font-medium" style={{ color: svc.color }}>
                    Get a quote <ArrowRight className="w-3.5 h-3.5" />
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* SECTORS SECTION */}
      <section id="sectors" className="section-reveal relative section-warm py-28 border-t border-white/5 overflow-hidden">
        <div className="absolute inset-0 pointer-events-none overflow-hidden" aria-hidden="true">
          <div className="perspective-grid-section"></div>
          <div className="horizon-glow-section"></div>
          <div className="scanlines" style={{ opacity: 0.35 }}></div>
          <div className="orb" style={{ width: 360, height: 360, background: 'rgba(184,137,46,0.1)', top: -80, right: -120 }}></div>
        </div>
        <div className="relative z-10 max-w-[1180px] mx-auto px-6 lg:px-10">
          <div className="text-center max-w-[820px] mx-auto mb-14">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-[11px] uppercase tracking-[0.22em] mb-5"
              style={{ color: 'rgb(212,168,91)', background: 'rgba(212,168,91,0.06)', border: '1px solid rgba(212,168,91,0.25)' }}>
              <SparklesIcon className="w-3 h-3" /> Sector-agnostic
            </div>
            <h2 className="font-serif-display text-white leading-[1.06]" style={{ fontSize: 'clamp(34px, 4.6vw, 56px)' }}>
              For any business,<br /><span className="text-gold-gradient">in any sector.</span>
            </h2>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-2.5">
            {['Healthcare', 'Hospitality', 'Real Estate', 'E-commerce', 'Finance', 'Logistics', 'Education', 'SaaS', 'Manufacturing', 'Automotive', 'Travel', 'Insurance', 'Legal', 'Media', 'Retail', 'NGOs'].map((sector) => (
              <div key={sector} className="glass-card rounded-xl px-3 py-4 text-center hover:border-[#d4a85b]/40 transition-all hover:-translate-y-1 group">
                <span className="text-[12.5px] text-neutral-300 font-medium group-hover:text-[#d4a85b] transition-colors">{sector}</span>
              </div>
            ))}
          </div>
          <p className="mt-8 text-center text-[12.5px] text-neutral-500">
            Not seeing yours?&nbsp;<a href="#contact" className="text-[#d4a85b] hover:underline">Tell us about your workflow</a>
          </p>
        </div>
      </section>

      {/* INSIGHTS / AGENTIC ERA SECTION */}
      <section id="insights" className="section-reveal relative py-28 border-t border-white/5 overflow-hidden" style={{ background: 'radial-gradient(ellipse 80% 60% at 50% 0%, rgba(212,168,91,0.07) 0%, transparent 60%), radial-gradient(ellipse 60% 50% at 50% 100%, rgba(184,137,46,0.06) 0%, transparent 60%), linear-gradient(180deg, #03040a, #070b18, #03040a)' }}>
        <div className="absolute inset-0 pointer-events-none overflow-hidden" aria-hidden="true">
          <div className="perspective-grid-top"></div>
          <div className="scanlines" style={{ opacity: 0.4 }}></div>
          <div className="orb" style={{ width: 500, height: 500, background: 'rgba(212,168,91,0.06)', top: -200, left: '50%', transform: 'translateX(-50%)', filter: 'blur(80px)' }}></div>
          <div className="orb" style={{ width: 300, height: 300, background: 'rgba(184,137,46,0.06)', bottom: -100, right: '10%', filter: 'blur(60px)' }}></div>
          <div className="orb" style={{ width: 280, height: 280, background: 'rgba(232,196,120,0.04)', bottom: -80, left: '10%', filter: 'blur(60px)' }}></div>
        </div>
        <div className="relative z-10 max-w-[1180px] mx-auto px-6 lg:px-10">
          <div className="max-w-[820px] mx-auto text-center mb-16">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-[10.5px] uppercase tracking-[0.3em] mb-6"
              style={{ color: '#d4a85b', background: 'rgba(212,168,91,0.06)', border: '1px solid rgba(212,168,91,0.2)' }}>
              <span className="live-dot" style={{ width: 6, height: 6 }}></span> Industry signals
            </div>
            <h2 className="font-serif-display leading-[1.06] tracking-tight text-white" style={{ fontSize: 'clamp(34px, 4.6vw, 58px)' }}>
              In the Agentic Era<br /><span className="text-gold-gradient">is already here.</span>
            </h2>
            <p className="mt-5 text-[15px] leading-[1.7]" style={{ color: 'rgba(180,200,240,0.6)', fontFamily: 'Inter' }}>
              The numbers don&apos;t lie. Every metric points to one direction.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
            {[
              { source: 'McKinsey', stat: '↑ All-time', label: 'AI adoption', icon: '📈' },
              { source: 'Gartner', stat: '$50B+', label: 'Market by 2030', icon: '💰' },
              { source: 'BCG', stat: '$TRN', label: 'Value unlocked', icon: '🔓' },
              { source: 'PwC', stat: '88%', label: 'Execs raising AI budgets', icon: '🏢' },
              { source: 'Ardem', stat: '240%', label: 'Average ROI', icon: '🚀' },
              { source: 'Protiviti', stat: '77%', label: 'Expect agentic decisions', icon: '🤖' },
            ].map((item, i) => (
              <div key={i} className="group relative rounded-2xl overflow-hidden" style={{ border: '1px solid rgba(212,168,91,0.12)', background: 'linear-gradient(135deg, rgba(212,168,91,0.04) 0%, rgba(8,12,26,0.8) 60%)' }}>
                <div className="absolute top-0 left-0 right-0 h-[1px]" style={{ background: 'linear-gradient(90deg, transparent, rgba(212,168,91,0.4), transparent)' }}></div>
                <div className="p-7 flex flex-col items-center text-center gap-3">
                  <div className="text-[18px] leading-none">{item.icon}</div>
                  <div className="font-mono-tech font-bold leading-none text-white" style={{ fontSize: 'clamp(18px, 2vw, 26px)' }}>{item.stat}</div>
                  <div className="text-[11px] font-medium" style={{ color: 'rgba(212,168,91,0.75)', fontFamily: 'Inter' }}>{item.label}</div>
                  <div className="text-[9px] uppercase tracking-[0.25em]" style={{ color: 'rgba(212,168,91,0.6)' }}>{item.source}</div>
                </div>
              </div>
            ))}
          </div>

          {/* Divider with trust indicators */}
          <div className="mt-16 flex flex-col items-center gap-6">
            <div className="flex items-center gap-3 w-full max-w-xl">
              <div className="flex-1 h-px bg-gradient-to-r from-transparent via-neutral-700 to-transparent" />
              <span className="text-[11px] uppercase tracking-[0.25em] text-neutral-500 whitespace-nowrap">Trusted Globally</span>
              <div className="flex-1 h-px bg-gradient-to-r from-transparent via-neutral-700 to-transparent" />
            </div>
            <div className="flex flex-wrap justify-center gap-8">
              {[
                { value: '10M+', label: 'Calls Handled' },
                { value: '99.9%', label: 'Uptime SLA' },
                { value: '<300ms', label: 'Response Time' },
                { value: '30+', label: 'Languages' },
              ].map((item) => (
                <div key={item.label} className="flex flex-col items-center gap-1">
                  <span className="text-xl font-semibold text-[#d4a85b]">{item.value}</span>
                  <span className="text-[11px] text-neutral-500 tracking-wide">{item.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Marquee */}
        <div className="mt-16 overflow-hidden border-y border-white/5 py-5 bg-white/[0.01]">
          <div className="flex marquee-track gap-3 whitespace-nowrap" style={{ width: 'max-content' }}>
            {[...marqueeItems, ...marqueeItems, ...marqueeItems, ...marqueeItems].map((item, i) => (
              <div key={i} className="flex items-center gap-3 px-5 py-2.5 rounded-full border border-white/[0.06] bg-white/[0.015]">
                <span className="text-[10px] uppercase tracking-[0.2em] text-[#d4a85b]">{item.source}</span>
                <span className="text-neutral-300 text-[12px]">{item.text}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* PROCESS SECTION */}
      <section id="process" className="section-reveal relative section-warm-deep py-28 border-t border-white/5 overflow-hidden">
        <div className="absolute inset-0 pointer-events-none overflow-hidden" aria-hidden="true">
          <div className="perspective-grid-section"></div>
          <div className="horizon-glow-section"></div>
          <div className="scanlines" style={{ opacity: 0.35 }}></div>
          <div className="orb" style={{ width: 360, height: 360, background: 'rgba(212,168,91,0.1)', top: -80, left: -120 }}></div>
        </div>
        <div className="relative z-10 max-w-[1180px] mx-auto px-6 lg:px-10">
          <div className="max-w-[820px] mx-auto text-center mb-16">
            <div className="text-[11px] uppercase tracking-[0.28em] text-[#d4a85b] mb-5">How we work</div>
            <h2 className="font-serif-display text-white leading-[1.06]" style={{ fontSize: 'clamp(34px, 4.6vw, 56px)' }}>
              Discovery to <span className="text-gold-gradient">go-live in 14 days.</span>
            </h2>
          </div>
          <div className="relative">
            <div
              className="hidden md:block absolute top-12 left-[8%] right-[8%] h-px"
              style={{ background: 'linear-gradient(90deg, transparent, rgba(212,168,91,0.5) 20%, rgba(212,168,91,0.5) 80%, transparent)' }}
            ></div>
            <div className="grid md:grid-cols-4 gap-6 relative">
              {[
                { num: '01', title: 'Discovery', sym: '🔍', color: '#d4a85b' },
                { num: '02', title: 'Proposal', sym: '📋', color: '#e8c478' },
                { num: '03', title: 'Onboard', sym: '⚙️', color: '#d4a85b' },
                { num: '04', title: 'Go-live', sym: '🚀', color: '#e8c478' },
              ].map((step) => (
                <div key={step.num} className="flex flex-col items-center text-center">
                  <div
                    className="relative w-16 h-16 rounded-2xl flex items-center justify-center mb-5 glass-card glitch-border"
                    style={{ background: `linear-gradient(135deg, ${step.color}22, rgba(3,4,10,0.6))` }}
                  >
                    <span className="text-[28px]">{step.sym}</span>
                  </div>
                  <div className="font-mono-tech text-[10px] tracking-widest mb-2" style={{ color: step.color }}>{step.num}</div>
                  <h3 className="text-white text-[18px] font-medium">{step.title}</h3>
                </div>
              ))}
            </div>
          </div>
          <div className="mt-16 flex items-center justify-center">
            <a href="#contact" className="btn-gold inline-flex items-center gap-2 px-6 py-3.5 rounded-full text-[14px] font-semibold">
              Start with a discovery call <ArrowRight className="w-4 h-4" />
            </a>
          </div>
        </div>
      </section>

      {/* TESTIMONIALS SECTION */}
      <section id="testimonials" className="section-reveal relative section-warm-center py-28 border-t border-white/5 overflow-hidden">
        <div className="absolute inset-0 pointer-events-none overflow-hidden" aria-hidden="true">
          <div className="perspective-grid-section"></div>
          <div className="horizon-glow-section"></div>
          <div className="scanlines" style={{ opacity: 0.35 }}></div>
          <div className="orb" style={{ width: 360, height: 360, background: 'rgba(184,137,46,0.1)', top: -80, left: -120 }}></div>
        </div>
        <div className="relative z-10 max-w-[1180px] mx-auto px-6 lg:px-10">
          <div className="text-center max-w-[720px] mx-auto mb-14">
            <div className="text-[11px] uppercase tracking-[0.28em] text-[#d4a85b] mb-5">Trusted across industries</div>
            <h2 className="font-serif-display text-white leading-[1.06]" style={{ fontSize: 'clamp(34px, 4.6vw, 56px)' }}>
              Results that<br /><span className="text-gold-gradient">speak for themselves.</span>
            </h2>
          </div>
          {/* Logo bar */}
          <div className="mt-4 grid grid-cols-2 md:grid-cols-4 lg:grid-cols-8 gap-px bg-white/5 rounded-2xl overflow-hidden border border-white/10">
            {['Northwind', 'BrightCart', 'ClinicQ', 'Quantica', 'Mosaic Labs', 'Voltura', 'Helix AI', 'Pelago'].map((name) => (
              <div key={name} className="bg-[#03040a] py-7 flex items-center justify-center text-neutral-400 hover:text-[#d4a85b] transition-colors hover:bg-white/[0.02]">
                <span className="font-serif-display text-[18px] tracking-wide">{name}</span>
              </div>
            ))}
          </div>
          {/* Testimonials */}
          <div className="mt-12 grid md:grid-cols-2 gap-3">
            {testimonials.map((t, i) => (
              <div key={i} className="holo-card rounded-2xl p-7">
                <div className="flex items-center gap-1 mb-4">
                  {[...Array(5)].map((_, j) => (
                    <StarIcon key={j} className="w-3.5 h-3.5 fill-[#d4a85b] text-[#d4a85b]" />
                  ))}
                </div>
                <p className="text-[15px] leading-[1.65] text-neutral-200">{t.text}</p>
                <div className="mt-6 flex items-center gap-3">
                  <div
                    className="w-10 h-10 rounded-full flex items-center justify-center text-[13px] font-semibold"
                    style={{ background: 'linear-gradient(135deg, rgb(232,196,120), rgb(212,168,91))', color: 'rgb(26,20,8)' }}
                  >
                    {t.initials}
                  </div>
                  <div>
                    <div className="text-[13.5px] text-white font-medium">{t.name}</div>
                    <div className="text-[12px] text-neutral-500">{t.role}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ SECTION */}
      <section id="faq" className="section-reveal relative section-warm py-28 border-t border-white/5 overflow-hidden">
        <div className="absolute inset-0 pointer-events-none overflow-hidden" aria-hidden="true">
          <div className="perspective-grid-top"></div>
          <div className="scanlines" style={{ opacity: 0.35 }}></div>
          <div className="orb" style={{ width: 360, height: 360, background: 'rgba(184,137,46,0.1)', top: -80, right: -120 }}></div>
        </div>
        <div className="relative z-10 max-w-[780px] mx-auto px-6 lg:px-10">
          <div className="flex flex-col items-center text-center gap-6 mb-12">
            <div className="text-[11px] uppercase tracking-[0.28em] text-[#d4a85b]">FAQ</div>
            <h2 className="font-serif-display text-white leading-[1.06]" style={{ fontSize: 'clamp(32px, 4vw, 48px)' }}>
              Frequently asked<br /><span className="text-gold-gradient">questions.</span>
            </h2>
            <p className="text-neutral-400 text-[14px] leading-[1.7]">
              Have a specific question? We reply within a business day.
            </p>
          </div>
          <div className="w-full">
            {faqItems.map((item, i) => (
              <div key={i} className="border-b border-white/10">
                <button
                  className="flex w-full items-center justify-between text-left text-[15px] font-medium text-white py-5 hover:no-underline transition-all"
                  onClick={() => setOpenFaq(openFaq === i ? null : i)}
                >
                  <span className="rgb-split">{item.q}</span>
                  <ChevronDownIcon
                    className={`h-4 w-4 shrink-0 text-neutral-500 transition-transform duration-200 ${openFaq === i ? 'rotate-180' : ''}`}
                  />
                </button>
                {openFaq === i && (
                  <div className="pb-5 text-[13.5px] text-neutral-400 leading-[1.7]">
                    {item.a}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* BOOK DEMO SECTION */}
      <section
        id="book-demo"
        className="relative py-24 border-t border-white/5 overflow-hidden"
        style={{ background: 'radial-gradient(55% 70% at 15% 40%, rgba(212,168,91,0.14) 0%, rgba(184,137,46,0.06) 35%, transparent 65%), radial-gradient(55% 70% at 85% 60%, rgba(184,137,46,0.18) 0%, rgba(212,168,91,0.06) 40%, transparent 70%), linear-gradient(rgb(3,4,10) 0%, rgb(7,11,24) 50%, rgb(3,4,10) 100%)' }}
      >
        <div className="absolute inset-0 pointer-events-none overflow-hidden" aria-hidden="true">
          <div className="perspective-grid-section"></div>
          <div className="horizon-glow-section"></div>
          <div className="scanlines" style={{ opacity: 0.35 }}></div>
          <div className="orb" style={{ width: 360, height: 360, background: 'rgba(212,168,91,0.1)', top: -80, left: -120 }}></div>
        </div>
        <div className="absolute -top-32 left-1/2 -translate-x-1/2 w-[700px] h-[700px] conic-glow opacity-20 pointer-events-none"></div>
        <div className="relative z-10 max-w-[1100px] mx-auto px-6 lg:px-10">
          <div className="glass-card rounded-3xl p-10 md:p-14 text-center" style={{ background: 'linear-gradient(rgba(6,10,24,0.8) 0%, rgba(3,4,10,0.9) 100%)' }}>
            <div
              className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-[10.5px] uppercase tracking-[0.24em] mb-6"
              style={{ color: 'rgb(212,168,91)', background: 'rgba(212,168,91,0.08)', border: '1px solid rgba(212,168,91,0.3)' }}
            >
              <CalendarClockIcon className="w-3 h-3" /> 45-minute walkthrough
            </div>
            <h2 className="font-serif-display text-white leading-[1.05]" style={{ fontSize: 'clamp(32px, 4.6vw, 56px)' }}>
              Want to see it in action?<br /><span className="text-gold-gradient neon-flicker">Book a demo.</span>
            </h2>
            <p className="mt-5 mx-auto max-w-[560px] text-[14.5px] leading-[1.7] text-neutral-400">
              Live MGriffin voice agent tuned to your industry. Written proposal within 5 working days.
            </p>
            <div className="mt-8 flex items-center justify-center gap-3 flex-wrap">
              <a href="#contact" className="btn-gold inline-flex items-center gap-2 px-7 py-3.5 rounded-full text-[14px] font-semibold glitch-border">
                Book a demo <ArrowRight className="w-4 h-4" />
              </a>
              <a
                href="#services"
                className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full text-[14px] font-medium"
                style={{ color: 'rgb(232,196,120)', border: '1px solid rgba(212,168,91,0.3)', background: 'rgba(20,14,4,0.5)', backdropFilter: 'blur(10px)' }}
              >
                Explore services
              </a>
            </div>
            <p className="mt-5 text-[11.5px] text-neutral-500">No obligation. Clear next step at the end of the call.</p>
          </div>
        </div>
      </section>

      {/* CONTACT SECTION */}
      <section id="contact" className="section-reveal relative section-warm-alt py-28 border-t border-white/5 overflow-hidden">
        <div className="absolute inset-0 pointer-events-none overflow-hidden" aria-hidden="true">
          <div className="perspective-grid-section"></div>
          <div className="horizon-glow-section"></div>
          <div className="scanlines" style={{ opacity: 0.35 }}></div>
          <div className="orb" style={{ width: 360, height: 360, background: 'rgba(184,137,46,0.14)', top: -80, right: -120 }}></div>
        </div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] conic-glow opacity-15 pointer-events-none"></div>
        <div className="relative z-10 max-w-[780px] mx-auto px-6 lg:px-10">
          <div className="flex flex-col items-center text-center mb-12">
            <div className="text-[11px] uppercase tracking-[0.28em] text-[#d4a85b] mb-5">Let&apos;s talk</div>
            <h2 className="font-serif-display text-white leading-[1.06]" style={{ fontSize: 'clamp(32px, 4vw, 52px)' }}>
              Contact us for<br />a <span className="text-gold-gradient">custom quote.</span>
            </h2>
            <p className="mt-4 text-neutral-400 text-[14px] leading-[1.7] max-w-[400px]">
              Custom-quoted after a 45-minute discovery call. Written proposal in five working days.
            </p>
            <ul className="mt-7 space-y-3">
              {['Discovery call within 24 hours', 'Written proposal in 5 working days', 'Go-live in 7–14 days after sign-off'].map((item) => (
                <li key={item} className="flex items-center gap-3 text-[13.5px] text-neutral-200">
                  <span className="w-5 h-5 rounded-full flex items-center justify-center" style={{ background: 'rgba(212,168,91,0.1)', border: '1px solid rgba(212,168,91,0.4)' }}>
                    <CheckIcon className="w-3 h-3 text-[#d4a85b]" />
                  </span>
                  {item}
                </li>
              ))}
            </ul>
            <div className="mt-10 pt-6 border-t border-white/10 w-full space-y-3 flex flex-col items-center">
              <div className="text-[11px] uppercase tracking-[0.22em] text-neutral-500">Prefer to talk now?</div>
              <a href="tel:+918849186404" className="flex items-center gap-3 text-[#d4a85b] text-[20px] font-medium tracking-wide hover:underline">
                <PhoneIcon className="w-4 h-4" /> +91 88491 86404
              </a>
              <a href="mailto:info@mgriffinsolutions.com" className="flex items-center gap-3 text-neutral-200 text-[14px] hover:text-[#d4a85b]">
                <MailIcon className="w-4 h-4 text-[#d4a85b]" /> info@mgriffinsolutions.com
              </a>
              <a href="https://wa.me/918849186404" target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 mt-1 px-4 py-2 rounded-full text-[13px] font-semibold btn-whatsapp">
                <MessageCircleIcon className="w-4 h-4" /> Chat on WhatsApp
              </a>
            </div>
          </div>
          {/* Contact Form */}
          <form className="glass-card rounded-2xl p-6 md:p-8" onSubmit={(e) => e.preventDefault()}>
            <div className="grid sm:grid-cols-2 gap-4">
              <div>
                <label className="text-[11px] uppercase tracking-[0.2em] text-neutral-500">Name</label>
                <input
                  placeholder="Your full name"
                  className="mt-2 w-full rounded-lg border border-white/10 bg-black/40 px-3 py-2.5 text-[13.5px] text-white placeholder:text-neutral-600 outline-none focus:border-[#d4a85b]/50 transition-colors"
                  type="text"
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                />
              </div>
              <div>
                <label className="text-[11px] uppercase tracking-[0.2em] text-neutral-500">Phone</label>
                <div className="mt-2 flex items-center gap-2 rounded-lg border border-white/10 bg-black/40 px-3 py-2.5">
                  <select
                    className="bg-transparent text-[13.5px] text-white outline-none"
                    value={formData.phoneCode}
                    onChange={(e) => setFormData({ ...formData, phoneCode: e.target.value })}
                  >
                    {['+1', '+44', '+91', '+61', '+49', '+33', '+81', '+86', '+971', '+65', '+27', '+55'].map((code) => (
                      <option key={code} value={code} className="bg-[#03040a]">{code}</option>
                    ))}
                  </select>
                  <input
                    placeholder="Phone number"
                    className="flex-1 bg-transparent text-[13.5px] text-white placeholder:text-neutral-600 outline-none"
                    value={formData.phone}
                    onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                  />
                </div>
              </div>
            </div>
            <div className="mt-4">
              <label className="text-[11px] uppercase tracking-[0.2em] text-neutral-500">Email</label>
              <input
                placeholder="you@company.com"
                className="mt-2 w-full rounded-lg border border-white/10 bg-black/40 px-3 py-2.5 text-[13.5px] text-white placeholder:text-neutral-600 outline-none focus:border-[#d4a85b]/50 transition-colors"
                type="email"
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
              />
            </div>
            <div className="mt-4">
              <label className="text-[11px] uppercase tracking-[0.2em] text-neutral-500">Website (optional)</label>
              <input
                placeholder="https://"
                className="mt-2 w-full rounded-lg border border-white/10 bg-black/40 px-3 py-2.5 text-[13.5px] text-white placeholder:text-neutral-600 outline-none focus:border-[#d4a85b]/50 transition-colors"
                type="text"
                value={formData.website}
                onChange={(e) => setFormData({ ...formData, website: e.target.value })}
              />
            </div>
            <div className="mt-4">
              <label className="text-[11px] uppercase tracking-[0.2em] text-neutral-500">Tell us about your workflow</label>
              <textarea
                rows={4}
                placeholder="What conversation do you want to automate?"
                className="mt-2 w-full rounded-lg border border-white/10 bg-black/40 px-3 py-2.5 text-[13.5px] text-white placeholder:text-neutral-600 outline-none focus:border-[#d4a85b]/50 transition-colors"
                value={formData.message}
                onChange={(e) => setFormData({ ...formData, message: e.target.value })}
              />
            </div>
            <button
              type="submit"
              className="btn-gold mt-6 w-full inline-flex items-center justify-center gap-2 px-5 py-3 rounded-full text-[14px] font-semibold glitch-border"
            >
              Request a quote <SendIcon className="w-4 h-4" />
            </button>
            <p className="text-[11px] text-neutral-500 mt-3 text-center">By submitting you agree to our terms. We never share your data.</p>
          </form>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="relative section-warm-deep border-t border-white/5 pt-20 pb-10 overflow-hidden">
        <div className="absolute inset-0 pointer-events-none overflow-hidden" aria-hidden="true">
          <div className="perspective-grid-top"></div>
          <div className="scanlines" style={{ opacity: 0.35 }}></div>
          <div className="orb" style={{ width: 360, height: 360, background: 'rgba(212,168,91,0.08)', top: -80, left: -120 }}></div>
        </div>
        <div className="relative z-10 max-w-[1180px] mx-auto px-6 lg:px-10">
          <div className="grid lg:grid-cols-[1.4fr_1fr_1fr_1fr] gap-10">
            <div className="flex flex-col items-center text-center">
              <div className="flex items-center gap-2">
                <div
                  className="relative flex items-center justify-center rounded-md glitch-block"
                  style={{ width: 32, height: 32, background: 'linear-gradient(135deg, #e8c478 0%, #d4a85b 100%)', boxShadow: 'rgba(212,168,91,0.6) 0px 4px 14px -4px, rgba(255,255,255,0.3) 0px 1px 0px inset' }}
                >
                  <span className="font-serif-display text-[#03040a] leading-none" style={{ fontSize: 20.8 }}>M</span>
                </div>
                <div className="leading-tight">
                  <div className="text-[15px] font-semibold tracking-tight text-white">MGriffin</div>
                  <div className="text-[10px] uppercase tracking-[0.18em] text-[#d4a85b]">Business Solutions</div>
                </div>
              </div>
              <p className="mt-5 text-[13px] text-neutral-400 leading-[1.7] max-w-[300px]">
                Conversational AI agents and the full growth stack. Never miss a call. Never lose a lead.
              </p>
              <div className="mt-6 space-y-2 text-[13px] text-neutral-300 w-full flex flex-col items-center">
                <a href="tel:+918849186404" className="flex items-center gap-2 hover:text-[#d4a85b]">
                  <PhoneIcon className="w-3.5 h-3.5 text-[#d4a85b]" /> +91 88491 86404
                </a>
                <a href="mailto:info@mgriffinsolutions.com" className="flex items-center gap-2 hover:text-[#d4a85b]">
                  <MailIcon className="w-3.5 h-3.5 text-[#d4a85b]" /> info@mgriffinsolutions.com
                </a>
                <a href="https://wa.me/918849186404" target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-emerald-400">
                  <MessageCircleIcon className="w-3.5 h-3.5 text-emerald-500" /> WhatsApp · +91 88491 86404
                </a>
              </div>
              <div className="mt-6 flex items-center justify-center gap-2">
                <a href="https://wa.me/918849186404" target="_blank" rel="noreferrer" aria-label="whatsapp" className="w-9 h-9 rounded-full border border-white/10 bg-white/[0.02] flex items-center justify-center hover:border-[#d4a85b]/50 transition-colors" style={{ color: 'rgb(43,214,106)' }}>
                  <MessageCircleIcon className="w-4 h-4" />
                </a>
                <a href="#contact" aria-label="twitter" className="w-9 h-9 rounded-full border border-white/10 bg-white/[0.02] flex items-center justify-center text-neutral-400 hover:text-[#d4a85b] hover:border-[#d4a85b]/50 transition-colors">
                  <TwitterIcon className="w-4 h-4" />
                </a>
                <a href="#contact" aria-label="linkedin" className="w-9 h-9 rounded-full border border-white/10 bg-white/[0.02] flex items-center justify-center text-neutral-400 hover:text-[#d4a85b] hover:border-[#d4a85b]/50 transition-colors">
                  <LinkedinIcon className="w-4 h-4" />
                </a>
                <a href="#contact" aria-label="github" className="w-9 h-9 rounded-full border border-white/10 bg-white/[0.02] flex items-center justify-center text-neutral-400 hover:text-[#d4a85b] hover:border-[#d4a85b]/50 transition-colors">
                  <GithubIcon className="w-4 h-4" />
                </a>
              </div>
            </div>
            <div className="flex flex-col items-center text-center">
              <div className="text-[11px] uppercase tracking-[0.22em] text-[#d4a85b] mb-4">Core product</div>
              <ul className="space-y-2.5">
                {[['Voice Agents', '#agents'], ['WhatsApp & Chat', '#services'], ['RAG Systems', '#services'], ['Integrations', '#services']].map(([label, href]) => (
                  <li key={label}><a href={href} className="text-[13px] text-neutral-400 hover:text-white transition-colors">{label}</a></li>
                ))}
              </ul>
            </div>
            <div className="flex flex-col items-center text-center">
              <div className="text-[11px] uppercase tracking-[0.22em] text-[#d4a85b] mb-4">Other services</div>
              <ul className="space-y-2.5">
                {[['WhatsApp Chatbot', '#more-services'], ['Digital Marketing', '#more-services'], ['Web Development', '#more-services'], ['Maintenance', '#more-services']].map(([label, href]) => (
                  <li key={label}><a href={href} className="text-[13px] text-neutral-400 hover:text-white transition-colors">{label}</a></li>
                ))}
              </ul>
            </div>
            <div className="flex flex-col items-center text-center">
              <div className="text-[11px] uppercase tracking-[0.22em] text-[#d4a85b] mb-4">Company</div>
              <ul className="space-y-2.5">
                {[['Process', '#process'], ['Sectors', '#sectors'], ['Testimonials', '#testimonials'], ['Book a demo', '#book-demo'], ['Contact', '#contact']].map(([label, href]) => (
                  <li key={label}><a href={href} className="text-[13px] text-neutral-400 hover:text-white transition-colors">{label}</a></li>
                ))}
              </ul>
            </div>
          </div>
          <div className="mt-16 pt-6 border-t border-white/5 flex flex-col md:flex-row items-center justify-center gap-3">
            <div className="text-[12px] text-neutral-500">© 2026 MGriffin Business Solutions. All rights reserved.</div>
            <div className="flex items-center gap-5 text-[12px] text-neutral-500">
              <a href="#contact" className="hover:text-neutral-300">Privacy</a>
              <a href="#contact" className="hover:text-neutral-300">Terms</a>
              <a href="#contact" className="hover:text-neutral-300">Security</a>
            </div>
          </div>
        </div>
        {/* Large watermark */}
        <div className="relative mt-14 select-none pointer-events-none overflow-hidden w-full flex justify-center">
          <div
            className="font-serif-display text-center leading-none glitch-text w-full"
            data-text="MGriffin"
            style={{ fontSize: 'clamp(80px, 18vw, 240px)', background: 'linear-gradient(rgba(212,168,91,0.15) 0%, rgba(212,168,91,0) 100%) text', WebkitBackgroundClip: 'text', backgroundClip: 'text', color: 'transparent', letterSpacing: '-0.04em', textAlign: 'center' }}
          >
            MGriffin
          </div>
        </div>
      </footer>

      {/* FLOATING CHAT WIDGET */}
      <ChatWidget />
    </div>
  );
}
